<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="flex flex-col h-full bg-white dark:bg-slate-900 w-full max-w-sm mx-auto rounded-xl overflow-hidden">
      <div class="px-6 py-4 border-b border-n-weak flex justify-between items-center bg-n-surface-1">
        <h2 class="text-base font-semibold m-0 text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="i-lucide-clock w-5 h-5 text-n-brand"></span>
          Agendar Mensagem
        </h2>
        <woot-button variant="clear" icon="dismiss" color-scheme="secondary" @click="onClose" />
      </div>
      <div class="flex-1 px-6 py-6 space-y-4">
        <p class="text-slate-600 dark:text-slate-300 text-sm">Selecione o momento exato em que esta mensagem será enviada ao contato.</p>
        <div class="w-full relative">
          <DateTimePicker
            :value="scheduledDate"
            placeholder="Escolher Data e Hora"
            confirm-text="Confirmar Horário"
            class="w-full"
            @change="handleDateChange"
          />
        </div>
      </div>
      <div class="flex justify-end gap-2 px-6 py-4 border-t border-n-weak bg-n-surface-2">
        <woot-button variant="clear" @click="onClose">
          Cancelar
        </woot-button>
        <woot-button :disabled="!scheduledDate" color-scheme="primary" @click="confirm">
          Agendar Envio
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import DateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';

export default {
  components: {
    DateTimePicker,
  },
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      scheduledDate: null,
    };
  },
  methods: {
    handleDateChange(date) {
      this.scheduledDate = date;
    },
    onClose() {
      this.$emit('close');
      setTimeout(() => {
        this.scheduledDate = null;
      }, 300);
    },
    confirm() {
      if (!this.scheduledDate) return;
      this.$emit('schedule', this.scheduledDate);
      this.onClose();
    },
  },
};
</script>
